module.exports = __webpack_public_path__ + "static/media/scrum7.508fbb48.png";